import React, { useState } from 'react';
import { ArrowLeft, Mail, CheckCircle } from 'lucide-react';
interface ForgotPasswordPageProps {
  onNavigate: (page: string) => void;
}
export function ForgotPasswordPage({
  onNavigate
}: ForgotPasswordPageProps) {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [error, setError] = useState('');
  const validateEmail = (value: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!email) {
      setError("L'email è obbligatoria.");
      return;
    }
    if (!validateEmail(email)) {
      setError('Inserisci un indirizzo email valido.');
      return;
    }
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      setIsSent(true);
    }, 1200);
  };
  return <div className="min-h-screen bg-green-600 flex flex-col items-center justify-center p-4 relative overflow-hidden" data-id="element-469">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-cover bg-center opacity-10" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/wsCbUWp4TF3ni7DwEfb9qP/hand-drawn-turtle-shell-pattern_23-2150598661.jpg)'
    }} data-id="element-470" />

      <div className="w-full max-w-md relative z-10" data-id="element-471">
        {/* Logo and Title */}
        <div className="text-center mb-6" data-id="element-472">
          <div className="inline-block bg-white rounded-2xl p-3 mb-3 shadow-lg" data-id="element-473">
            <img src="https://cdn.magicpatterns.com/uploads/w4Sqqi6gRHWGegGAQT2PTG/Greenback_logo_(1).png" alt="Greenback Logo" className="h-10 w-auto" data-id="element-474" />
          </div>
          <h1 className="text-xl font-normal text-white" data-id="element-475">Recupera password</h1>
        </div>

        {/* Card */}
        <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100" data-id="element-476">
          {!isSent ? <>
              <p className="text-sm text-gray-600 mb-5 leading-relaxed" data-id="element-477">
                Inserisci l'email associata al tuo account. Ti invieremo un link
                per reimpostare la password.
              </p>

              <form onSubmit={handleSubmit} className="space-y-4" noValidate data-id="element-478">
                {/* Email Input */}
                <div className="space-y-1.5" data-id="element-479">
                  <label className="text-sm font-normal text-gray-700 block" data-id="element-480">
                    Email <span className="text-red-500" data-id="element-481">*</span>
                  </label>
                  <div className="relative" data-id="element-482">
                    <input type="email" value={email} onChange={e => {
                  setEmail(e.target.value);
                  setError('');
                }} className={`block w-full px-4 py-2.5 border rounded-xl text-gray-900 placeholder-gray-400 placeholder:text-sm focus:outline-none focus:ring-1 transition-colors text-sm ${error ? 'border-red-400 focus:border-red-400 focus:ring-red-400' : 'border-gray-200 focus:border-green-500 focus:ring-green-500'}`} placeholder="alexrossi@example.com" data-id="element-483" />
                  </div>
                  {error && <p className="text-xs text-red-500 flex items-center gap-1 mt-1" data-id="element-484">
                      <span data-id="element-485">⚠</span> {error}
                    </p>}
                </div>

                {/* CTA */}
                <button type="submit" disabled={isLoading} className="w-full flex items-center justify-center py-3 px-4 rounded-full shadow-sm text-sm font-normal text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-486">
                  {isLoading ? <div className="h-5 w-5 border-2 border-white border-t-transparent rounded-full animate-spin" data-id="element-487" /> : 'Invia link di recupero'}
                </button>
              </form>
            </> /* Success State */ : <div className="text-center py-4" data-id="element-488">
              <div className="flex justify-center mb-4" data-id="element-489">
                <CheckCircle className="h-14 w-14 text-green-500" strokeWidth={1.5} data-id="element-490" />
              </div>
              <h3 className="text-base font-normal text-gray-900 mb-2" data-id="element-491">
                Email inviata!
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-6" data-id="element-492">
                Controlla la tua casella di posta. Hai ricevuto un link per
                reimpostare la password.
              </p>
              <button onClick={() => onNavigate('login')} className="w-full py-3 px-4 rounded-full text-sm font-normal text-white bg-green-600 hover:bg-green-700 transition-all" data-id="element-493">
                Torna al login
              </button>
            </div>}

          {/* Back to login */}
          {!isSent && <button onClick={() => onNavigate('login')} className="w-full mt-4 flex items-center justify-center gap-1.5 text-xs text-gray-500 hover:text-gray-700 transition-colors" data-id="element-494">
              <ArrowLeft className="h-3.5 w-3.5" data-id="element-495" />
              Torna al login
            </button>}
        </div>

        {/* Footer */}
        <p className="text-center text-xs text-white/80 mt-4" data-id="element-496">
          © 2026 Greenback. Tutti i diritti riservati.
        </p>
      </div>
    </div>;
}